import React from 'react';

const CustomCheckbox = ({
  checked,
  onChange,
  disabled = false,
  label,
  loading = false,
  labelClass = '',
  color = 'primary' | 'secondary' | 'black',
  style,
  compact = false,
  size = 'medium',
}) => {
  const hasLabel = label !== undefined && label !== null && label !== '';
  const isCompact = compact || !hasLabel;

  return (
    <label
      className={`flex items-center cursor-pointer relative ${
        isCompact ? '' : 'pl-6'
      } text-sm font-medium text-gray-700 select-none transition-opacity duration-200 hover:opacity-80 ${
        disabled || loading ? 'opacity-60 cursor-not-allowed' : ''
      }`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled || loading}
        className="absolute opacity-0 cursor-pointer h-0 w-0"
      />
      <span
        className={`${
          isCompact
            ? 'relative left-0 top-0 transform-none'
            : 'absolute left-0 top-1/2 transform -translate-y-1/2'
        } ${
          size === 'small' ? 'h-3.5 w-3.5' : 'h-4 w-4'
        } border-2 border-solid rounded transition-all duration-200 ${
          checked
            ? `${
                color === 'secondary'
                  ? 'bg-primary-yellow border-primary-yellow'
                  : color === 'black'
                  ? 'bg-black border-black'
                  : 'bg-blue-500 border-blue-500'
              } `
            : 'border-icon-gray border-2 border-solid hover:border-gray-400'
        }`}
        style={style}>
        {checked && (
          <svg
            className={`absolute inset-0 top-px w-full h-full ${
              color === 'secondary'
                ? 'text-gray-6000'
                : color === 'black'
                ? 'text-white'
                : 'text-white'
            }`}
            viewBox="0 0 16 16"
            fill={'currentColor'}>
            <path d="M13.5 3.5L6 11L2.5 7.5L3.5 6.5L6 9L12.5 2.5L13.5 3.5Z" />
          </svg>
        )}
      </span>
      {hasLabel && (
        <span
          className={`ml-1   ${
            labelClass ||
            `text-sm text-icon-gray ${
              checked ? 'font-bold text-primary-blue' : ''
            }`
          }`}>
          {label}
        </span>
      )}
    </label>
  );
};

export default CustomCheckbox;
